import getChoiceGroupSelection from './getChoiceGroupSelection';
import getForwardingEmailAddress from './getForwardingEmailAddress';
import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';

export default function isForwardingFormInvalid() {
    return (
        getChoiceGroupSelection() === 'start' && !isValidEmailAddress(getForwardingEmailAddress())
    );
}
